import { addClassName } from '@hc-frontend/core-utils-format';

import type { FormGroupProps } from './form-group.types';

function getClass(disabled?: boolean, error?: boolean) {
  if (error) return 'hc-form-group__stack--error';
  if (disabled) return 'hc-form-group__stack--disabled';
  return 'hc-form-group__stack--active';
}

export function FormGroup({
  error,
  disabled,
  children,
  className,
  // eslint-disable-next-line no-undef
}: FormGroupProps): React.ReactNode {
  return (
    <div
      className={addClassName(
        'hc-stack-layout--small',
        'hc-form-group__stack',
        getClass(disabled, error),
        className,
      )}
    >
      {children}
    </div>
  );
}
